import React, { useEffect, useState } from 'react';

import Tabs from '../../shared/Tabs/Tabs';
import TabPanel from '../../shared/Tabs/TabPanel';
import Overview from './StagesTabs/Overview';
import Solve from './StagesTabs/Solve';
import Submit from './StagesTabs/Submit';
import { ProgramSetupAxios } from '../../API';
import { useDispatch, useSelector } from 'react-redux';
import journeyMapSlice from '../../store/journeyMap/journeyMapSlice';
import appStateSlice from '../../store/appState/appStateSlice';
import axios from 'axios';

let stageCancelToken = axios.CancelToken.source();

const JourneyStage = () => {
    const dispatch = useDispatch();
    const [stageDetails, setStageDetails] = useState({});
    const stageActivities = useSelector((state) => state.journeyMapSlice.stageActivities);
    const activeTab = useSelector((state) => state.appState.activeTab);
    const userDetails = useSelector((state) => state.auth.loggedInUser);
    const allActivities = useSelector((state) => state.auth.missionDetails.tasks);
    //const journeyMap = useSelector((state) => state.journeyMapSlice.journeyMap);
    //const userTokenData = useSelector((state) => state.auth.tokenData);
    const currentStageId = useSelector((state) => state.appState.currentStage) || userDetails.currentStageId;
    const tabs = useSelector((state) => state.appState.stageTabs);
    const [stageTabs, setStageTabs] = useState([]);
    const [currentCommnetText, setCurrentCommnetText] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getActivityList();
        setCurrentCommnetText('');
    }, [currentStageId]);

    useEffect(() => {
        if (currentCommnetText.length > 0) {
            dispatch(appStateSlice.actions.setIsTyping(true));
        } else {
            dispatch(appStateSlice.actions.setIsTyping(false));
        }
    }, [currentCommnetText]);

    const getActivityList = () => {
        stageCancelToken.cancel();
        stageCancelToken = axios.CancelToken.source();
        setStageTabs(tabs);
        setIsLoading(true);
        ProgramSetupAxios.get('/OfferingStage/getstagedetailsbyofferinguser/' + currentStageId + '/' + userDetails.offeringUserId, { cancelToken: stageCancelToken.token })
            .then(function (response) {
                setIsLoading(false);
                let data = response.data;
                setStageDetails(data);
                data.activities.sort((a, b) => parseInt(a.sequence) > parseInt(b.sequence) ? 1 : -1);
                dispatch(journeyMapSlice.actions.setStageActivities(data.activities));
                let activity = allActivities.find(x => x.activityTypeId === 4);
                if (activity) {
                    let currentTabs = [...tabs];
                    var tempcurrentTabs = currentTabs.map((item) => {
                        let isDis = false;
                        if (item.name === 'Submit') {
                            isDis = !activity.isUnlocked;
                        }
                        return { ...item, isDisable: isDis };
                    });

                    dispatch(appStateSlice.actions.setStageTabs(tempcurrentTabs));
                    let individualActivity = allActivities.some(x => x.activityTypeId === 3 && x.stageId == currentStageId);
                    if(!individualActivity)
                    {
                        tempcurrentTabs = tempcurrentTabs.filter(x => x.name !== 'Solve');
                    }
                    setStageTabs(tempcurrentTabs);

                }
            })
            .catch(function (error) {
                setIsLoading(false);
                console.log(error);
            });
    };

    // const addDemoDescr = (items) => {

    //     let longDescription = [
    //         { status: 0, text: "Meet your team at a mutually agreed time to discuss and collate your findings. Synthesize your insights and recommendations into alternatives that you can review with your Coach during Huddle 2." },
    //         { status: 0, text: "Submit your individual and collate findings, insights, and recommendations to your Coach. Remember to cite your sources of research." },
    //         { status: 0, text: "Submit your individual and collate findings, insights, and recommendations to your Coach." }
    //     ]

    //     return items.map(item => {
    //         return { ...item, longDescription: "Meet your team at a mutually agreed time to discuss and collate your findings. Synthesize your insights and recommendations into alternatives that you can review with your Coach during Huddle 2." }
    //     })
    // }

    return (<>
        <Tabs tabs={stageTabs} activeTab={activeTab} />

        <TabPanel value={activeTab} name="Overview" key="Overview" loading={isLoading}>
            <Overview stageDetails={stageDetails} activities={stageActivities} />
        </TabPanel>
        <TabPanel value={activeTab} name="Solve" key="Solve" loading={isLoading}>
            <Solve setCommentText={setCurrentCommnetText} commentText={currentCommnetText} setIsLoading={setIsLoading} />
        </TabPanel>
        <TabPanel value={activeTab} name="Submit" key="Submit" loading={isLoading} >
            <Submit />
        </TabPanel>
    </>
    );
};

export default JourneyStage;